/**
 * Group pins — the SAME per-user campaign pins as the SMSWiser page: a group
 * is pinned when every member is, and pinning a group pins every member
 * (SMSWiser's own rule). Only users who can open the SMSWiser page can pin;
 * everyone else simply sees no pins.
 * For Media Devoted | Created By Ciro Autiero
 */
import {
  useMySmswiserCampaignPins,
  usePinSmswiserCampaign,
  useUnpinSmswiserCampaign,
} from '@/hooks/smswiser/campaigns/useSmswiserCampaigns';
import { useAuth } from '@/providers/AuthProvider';

export function useCampaignPins(countryKey: string) {
  const { hasPermission } = useAuth();
  const canPin = hasPermission('drops.view') || hasPermission('stats.phone');
  const pins = useMySmswiserCampaignPins({ enabled: canPin });
  const pin = usePinSmswiserCampaign();
  const unpin = useUnpinSmswiserCampaign();
  const key = countryKey.toLowerCase();
  const pinned = (pins.data ?? []).filter((p) => p.countryKey.toLowerCase() === key).map((p) => p.wiserId);
  return {
    canPin,
    pinned,
    busy: pin.isPending || unpin.isPending,
    toggle: (wiserIds: number[], on: boolean) =>
      wiserIds.forEach((wiserId) => (on ? pin : unpin).mutate({ countryKey, wiserId })),
  };
}
